export enum PersonalDocumentType {
	IDCard = 'ID',
	passport = 'P',
}
